import CCColors from '@/Utils/CCColors';
import {isPhone} from '@/Utils/Dimensions';
import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  container: {
    flexDirection: isPhone ? 'column' : 'row',
    flex: 1,
    overflow: 'scroll',
  },
  mobileContainer: {
    flex: 1,
  },
  left: {
    flex: 0.2,
    paddingHorizontal: 20,
    paddingTop: 10,
    height: '80vh',
  },
  chessboardContainer: {
    flexDirection: 'column',
    // // flex: (isPhone || isPortrait) ? 1 : 0.6,
    // overflow: 'visible',
    // backgroundColor: '#FAF6EB',
    // flex: 2,
    width: isPhone ? '100%' : '80%',
    // marginLeft: isPhone || isPortrait ? 0 : '2%',
    // marginRight: isPhone || isPortrait ? 0 : '2%',
    // height: '100%',
  },
  center: {
    flex: 0.5,
    alignItems: 'center',
    justifyContent: 'flex-start',
    // width: '70%',
  },
  right: {flex: 0.3, padding: 10},
  addNewBox: {
    backgroundColor: CCColors.Primary.Brown,
    padding: 10,
    borderRadius: 8,
  },
  disabled: {
    backgroundColor: CCColors.Grey.Shade200,
    padding: 10,
    borderRadius: 8,
  },
});
